var app = angular.module("nms.deviceSummary", []);

app.config(["$translatePartialLoaderProvider", function($translatePartialLoader) {
    $translatePartialLoader.addPart("features/device-summary");
}]);

app.run(["$translate",
    function($translate) {
        $translate.refresh();
    }
]);
